<template>
  <div>
    <v-row>
      <!-- filter bar -->
      <v-col cols="7" class="d-flex">
        <!-- filter btn -->
        <v-btn
          tile
          small
          depressed
          color="grey lighten-3"
          height="100%"
          class="rounded-l text-none"
          @click="showFilterPopup"
        >
          <span class="mr-2">Filter</span>
          <v-icon>mdi-sort-variant</v-icon>
        </v-btn>
        <!-- filter name field -->
        <v-text-field
          v-model="innerVal.name"
          dense
          outlined
          hide-details
          prepend-inner-icon="mdi-magnify"
          placeholder="Search Doctors"
          class="rounded-l-0 rounded-r"
        ></v-text-field>
      </v-col>
      <!-- hour switch -->
      <v-col cols="4" class="d-flex">
        <v-switch
          dense
          hide-details
          color="success"
          height="10px"
          label="Available for the next 2-3 hrs"
          class="my-auto ml-auto"
        ></v-switch>
      </v-col>
    </v-row>
    <!-- active filters -->
    <v-row>
      <!-- specializations -->
      <v-chip
        v-for="(filters,index) in innerVal.specializations"
        :key="filters"
        close
        small
        color="grey lighten-3 custom-chip"
        close-icon="mdi-close"
        class="mx-2 pa-4"
        @click:close="innerVal.specializations.splice(index, 1)"
      >
        {{ filters }}
      </v-chip>

      <!-- status -->
      <v-chip
        v-for="(filters,index) in innerVal.status"
        :key="filters"
        close
        small
        color="grey lighten-2"
        close-icon="mdi-close"
        class="mx-2 pa-4 custom-chip"
        @click:close="innerVal.status.splice(index, 1)"
      >
        {{ filters }}
      </v-chip>
    </v-row>

    <!-- filter popup -->
    <v-dialog v-model="filter.show" max-width="550px">
      <v-card>
        <v-card-title class="primary--text">
          <span>Filter Search</span>
          <v-icon
            class="ml-auto"
            @click="cancelFilter"
          >
            mdi-close
          </v-icon>
        </v-card-title>
        
        <v-card-text>
          <!-- specialization list -->
          <h3 class="mb-2">Specialization</h3>
          <v-row dense>
            <!-- specialization item -->
            <v-col
              v-for="(specialization, index) in filter.specializations"
              :key="index"
              cols="4"
              class="pa-0"
            >
              <v-checkbox
                v-model="filter.saved.specializations"
                dense
                hide-details
                class="ma-0"
                :label="specialization"
                :value="specialization"
              ></v-checkbox>
            </v-col>
          </v-row>

          <!-- status list -->
          <h3 class="mt-4 mb-2">Status</h3>
          <v-row dense>
            <v-col
              v-for="(status,index) in filter.status"
              :key="index"
              cols="4"
              class="pa-0"
            >
              <v-checkbox
                v-model="filter.saved.status"
                dense
                hide-details
                class="ma-0"
                :label="status"
                :value="status"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        
        <v-card-actions class="justify-center pb-6">
          <v-btn
            rounded
            depressed
            color="primary lighten-4 primary--text"
            width="100px"
            class="mx-3"
            @click="cancelFilter"
          >
            Cancel
          </v-btn>
          <v-btn
            rounded
            depressed
            color="primary"
            width="100px"
            class="mx-3"
            @click="confirmFilter"
          >
            Filter
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: 'DoctorsTableFilter',
    
    props: {
      value: {
        type:[ Object, Array ],
        default() {
          return {
            name: null,
            specialization: [],
            status: []
          }
        }
      }
    },

    data() {
      return {
        innerVal: this.value,
        filter: {
          show: false,
          saved: {
            specializations: [],
            status: []
          },
          specializations: [
            'Cardiology',
            'Endocrinology',
            'Family Medicine',
            'Gastro',
            'Internal',
            'Pediatric',
            'OBGyn',
            'Anesthesiology',
            'General Practice',
            'General Surgery',
            'Ophthalmology',
          ],
          status: [
            'online',
            'in call',
            'acw',
            'on break'
          ]
        }
      }
    },

    watch: {
      value(val) {
        this.innerVal = val
      },
      innerVal(val) {
        this.$emit('input', val)
      }
    },

    methods: {
      showFilterPopup() {
        this.filter.show = true
      },
      hideFilterPopup() {
        this.filter.show = false
        this.filter.saved.specializations = []
        this.filter.saved.status = []
      },
      cancelFilter() {
        this.hideFilterPopup()
      },
      confirmFilter() {
        this.innerVal.specializations = this.filter.saved.specializations
        this.innerVal.status = this.filter.saved.status
        this.hideFilterPopup()
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>

<style lang="scss">
  // for properties that needs to be unscoped to worked

  .custom-chip {
    button {
      color: red !important;
    }
  }
</style>
